import React, { useState } from "react";
import { Row, Col, Card, Form, Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import titletext from "../../Images/shutteltext.png";
import Layout from "../../layout/fullpage";
import { FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import { Media, MediaGroup, Image, Logo } from "../../components";
import { Spinner } from "react-bootstrap";
import image from "../../assets/images/bg-image/bg-image.jpg";
import image1 from "../../Images/bgimg1.png";
import { confirmforgotPassword } from "../../services/AuthService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
function Authsetpwd() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const uid = searchParams.get("uid");
  const token = searchParams.get("token");
  const [showPwd, setShowPwd] = useState(false);
  const [cshowPwd, setCshowPwd] = useState(false);
  const [pwd, setPwd] = useState("");
  const [cpwd, setCpwd] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    if (name === "password") {
      setPwd(value);
      if (cpwd && value !== cpwd) {
        setError("Passwords do not match");
      } else {
        setError("");
      }
    } else if (name === "cpassword") {
      setCpwd(value);
      if (pwd && pwd !== value) {
        setError("Passwords do not match");
      } else {
        setError("");
      }
    }
  };

  const confirmpassword = async (e) => {
    e.preventDefault();
    const payload = {
      token: token || "",
      user_id: uid || "",
      password: pwd || "",
    };
    try {
      setLoading(true);
      const response = await confirmforgotPassword(payload);
      if (response) {
        toast.success("Password Reset successfully");
        navigate("/");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };
  return (
    // <Layout title="Forgot Password" centered>
    <div className="d-flex align-items-center justify-content-center vh-100 vw-100">
      <div className="my-responsive-box">
        <Card className="h-100 w-100">
          {/* <Card className="w-100 overflow-hidden card-gutter-lg rounded-4 card-auth card-auth-mh"> */}
          <Row className="h-100 w-100 g-0 flex-lg-row-reverse">
            <Col lg="5" style={{ padding: "20px" }}>
              <Card.Body className="h-100 d-flex flex-column justify-content-center">
                <div className="nk-block-head text-center">
                  <div className="d-flex align-item-center justify-content-center flex-grow mb-3">
                    <img src={titletext} alt="" width={"200px"} />
                  </div>
                  <div className="nk-block-head-content">
                    <h5 className="nk-block-title mb-2">Set Password</h5>
                  </div>
                </div>
                <Form onSubmit={confirmpassword}>
                  <div className="row">
                    <div className="col-12 mb-2">
                      <label className="form-label">Password</label>
                      <div className="position-relative">
                        <input
                          name="password"
                          type={showPwd ? "text" : "password"}
                          placeholder="*****"
                          value={pwd}
                          onChange={handlePasswordChange}
                          className="form-control px-5"
                        />
                        {/* Lock Icon (left) */}
                        <FaLock
                          className="position-absolute top-50 translate-middle-y text-primary"
                          style={{ left: "15px", pointerEvents: "none" }}
                        />
                        {/* Toggle Eye Icon (right) */}
                        <div
                          className="position-absolute top-50 translate-middle-y"
                          style={{ right: "15px", cursor: "pointer" }}
                          onClick={() => setShowPwd((prev) => !prev)}
                        >
                          {!showPwd ? <FaEyeSlash /> : <FaEye />}
                        </div>
                      </div>
                    </div>
                    <div className="col-12 mb-2">
                      <label className="form-label">Confirm Password</label>
                      <div className="position-relative">
                        <input
                          name="cpassword"
                          type={cshowPwd ? "text" : "password"}
                          placeholder="*****"
                          className="form-control px-5"
                          value={cpwd}
                          onChange={handlePasswordChange}
                        />
                        {/* Lock Icon (left) */}
                        <FaLock
                          className="position-absolute top-50 translate-middle-y text-primary"
                          style={{ left: "15px", pointerEvents: "none" }}
                        />
                        {/* Toggle Eye Icon (right) */}
                        <div
                          className="position-absolute top-50 translate-middle-y"
                          style={{ right: "15px", cursor: "pointer" }}
                          onClick={() => setCshowPwd((prev) => !prev)}
                        >
                          {!cshowPwd ? <FaEyeSlash /> : <FaEye />}
                        </div>
                      </div>
                    </div>
                    {error && <div style={{ color: "red" }}>{error}</div>}
                  </div>
                  <div className="row mt-2">
                    <div className="col">
                      <button
                        className="btn btn-primary w-100"
                        disabled={error || !pwd || !cpwd}
                        type="submit"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </Form>
                <div className="text-center mt-4">
                  <p className="small">
                    <Link to="/">Back to Login</Link>
                  </p>
                </div>
              </Card.Body>
            </Col>
            <div className="d-none d-lg-block col-lg-7">
              <Card.Body
                className="is-theme has-mask has-mask-1 h-100 d-flex flex-column justify-content-end"
                style={{
                  backgroundImage: `url(${image1})`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                }}
                centered
              >
                {/* <div className="brand-logo">
                  <Logo />
                </div> */}
                <div className="row">
                  <div className="col-sm-11">
                    <div className="mt-4">
                      {/* <div className="h1 title mb-3">
                        Welcome to <br /> InteliShuttle
                      </div>
                      <p>
                        Experience smarter Bus Pass management and seamless
                        operations to enhance productivity and efficiency.
                      </p> */}
                    </div>
                  </div>
                </div>
              </Card.Body>
            </div>
          </Row>
        </Card>
        {/* </Card> */}
      </div>
    </div>
    // </Layout>
  );
}

export default Authsetpwd;
